import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle, Shield } from 'lucide-react';
import axios from 'axios';

const SuccessPage = () => {
  const [searchParams] = useSearchParams();
  const [checking, setChecking] = useState(true);
  const [status, setStatus] = useState(null);
  const navigate = useNavigate();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (sessionId) {
      checkPaymentStatus();
    } else {
      navigate('/dashboard');
    }
  }, [sessionId]);

  const checkPaymentStatus = async (attempt = 0) => {
    if (attempt >= 5) {
      setStatus('timeout');
      setChecking(false);
      return;
    }
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/payments/status/${sessionId}`,
        { withCredentials: true }
      );
      if (data.payment_status === 'paid') {
        setStatus('success');
        setChecking(false);
      } else {
        setTimeout(() => checkPaymentStatus(attempt + 1), 2000);
      }
    } catch (error) {
      setTimeout(() => checkPaymentStatus(attempt + 1), 2000);
    }
  };

  if (checking) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Confirming your payment...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex justify-center">
          {status === 'success' ? (
            <CheckCircle className="w-20 h-20 text-green-500" />
          ) : (
            <Shield className="w-20 h-20 text-blue-600" />
          )}
        </div>
        <h2 className="mt-6 text-center text-3xl font-bold text-gray-900">
          {status === 'success' ? 'Payment Successful!' : 'Processing Payment'}
        </h2>
        <p className="mt-2 text-center text-gray-600">
          {status === 'success'
            ? 'Your subscription has been activated. Welcome to InvestiGate!'
            : 'Your payment is being processed. This may take a few moments.'}
        </p>
        <div className="mt-8 text-center">
          <button
            onClick={() => navigate('/dashboard')}
            className="bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 transition font-semibold"
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessPage;
